export const StoreGetters = {
};

export const getters = {
}